import service from '@/utils/request';
let { postRequestJson} = service;//轮播列表

export function applications(params) { 
    return postRequestJson('crossDomain/svc/applications/addApplication', params)
}